import React, { useState } from 'react';

interface MapTypeToggleProps {
  map: kakao.maps.Map | null;
}

const MapTypeToggle: React.FC<MapTypeToggleProps> = ({ map }) => {
  const [isSatellite, setIsSatellite] = useState(false);

  const toggleMapType = () => {
    if (!map) return;
    
    const currentType = map.getMapTypeId();
    if (currentType === kakao.maps.MapTypeId.ROADMAP) {
      map.setMapTypeId(kakao.maps.MapTypeId.HYBRID);
      setIsSatellite(true);
    } else {
      map.setMapTypeId(kakao.maps.MapTypeId.ROADMAP);
      setIsSatellite(false);
    }
  };

  return (
    <button
      onClick={toggleMapType}
      className="absolute top-4 right-4 z-50 bg-bluesignal-pre-blue text-white p-2 rounded-md font-semibold shadow-md hover:bg-bluesignal-blue transition-colors text-sm outline-none"
    >
      {isSatellite ? '일반지도' : '위성지도'}
    </button>
  );
};

export default MapTypeToggle; 